// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"e3f0265c","453":"64aababc","879":"84f92024"}[chunkId] + ".chunk.js";
};